/** Attribute on the admin sidebar <aside> so we can find it across AdminLayout remounts. */
export const ADMIN_SIDEBAR_SCROLL_ATTR = "data-admin-sidebar-scroll";

let pendingRestore = false;
let savedSidebar = 0;
let savedMain = 0;

function getDocumentScrollTop(): number {
  return (
    window.scrollY ||
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    0
  );
}

function setDocumentScrollTop(y: number): void {
  window.scrollTo(0, y);
}

function getSidebarElement(): HTMLElement | null {
  return document.querySelector(`[${ADMIN_SIDEBAR_SCROLL_ATTR}]`);
}

/**
 * Call from sidebar links immediately before `navigate()`.
 * State lives in this module so it survives `AdminLayout` remounting on each route.
 */
export function captureAdminNavScroll(): void {
  pendingRestore = true;
  const aside = getSidebarElement();
  savedSidebar = aside?.scrollTop ?? 0;
  savedMain = getDocumentScrollTop();
}

export function consumeAdminNavScrollRestore(): {
  sidebar: number;
  main: number;
} | null {
  if (!pendingRestore) {
    return null;
  }
  pendingRestore = false;
  return { sidebar: savedSidebar, main: savedMain };
}

export function applyRestoredScroll(sidebar: number, main: number): void {
  const aside = getSidebarElement();
  const apply = () => {
    if (aside) {
      aside.scrollTop = sidebar;
    }
    setDocumentScrollTop(main);
  };
  apply();
  requestAnimationFrame(() => {
    apply();
    requestAnimationFrame(apply);
  });
}
